import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentProjectDetailPageContext,
  ComponentProjectDetailPageInitialState,
} from ".";

export const ComponentProjectDetailPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    ComponentProjectDetailPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentProjectDetailPageContext.Provider value={context}>
      {children}
    </ComponentProjectDetailPageContext.Provider>
  );
};
